import { mutator } from 'satcheljs';
import { onAccountChanged } from '../actions';
import { getAppStore } from '../store/store';

mutator(onAccountChanged, msg => {
  const store = getAppStore();
  store.account = msg.account;
});
